<dialog
  #appDialog
  class="modal-dialog modal-lg p-0 border-0 shadow-lg"
>
  <div class="modal-content border-0">
    <!-- Modal Header -->
    <div class="modal-header py-3 px-4 bg-light text-dark position-relative border-bottom">
      <h5 class="modal-title m-0">
        <span *ngIf="theManco?.ticketNumber === ''">Nieuw</span>
        <span *ngIf="!(theManco?.ticketNumber === '')">
          Freshdesk ticket:
          <a
            href="{{
              (theManco !== undefined && theManco.ticketNumber !== null ? theManco.ticketNumber : '')
                | freshdeskTicketLink
            }}"
            target="_blank"
            class="text-decoration-none text-primary"
            >{{ theManco?.ticketNumber }}</a
          >
        </span>
      </h5>
      <button
        type="button"
        class="btn-close modal-button"
        aria-label="Close"
        (click)="closeDialog('cancel')"
      ></button>
    </div>

    <!-- Modal Body -->
    <div class="modal-body">
      <app-manco-form
        [theManco]="theManco"
        (formSubmit)="handleSubmit($event)"
      ></app-manco-form>
    </div>
  </div>
</dialog>
